var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h96v96H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 60c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24c-.014 13.249-10.751 23.986-24 24zm0-44c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20c-.013-11.04-8.96-19.987-20-20z",
    fill: "#717171",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74 96a10.192 10.192 0 0 1-7.256-3.006l-22.988-24.93a1.978 1.978 0 0 0-2.402-.386 36.04 36.04 0 0 1-18.642 4.288C15.06 71.408-.287 55.377 0 35.98.037 16.124 16.124.037 35.98 0h.022c19.39-.276 35.407 15.069 35.964 34.452a35.992 35.992 0 0 1-4.286 18.64 1.984 1.984 0 0 0 .39 2.41l24.866 22.926.06.056A10.26 10.26 0 0 1 85.736 96h.004zM54.048 63.434a5.954 5.954 0 0 1 4.388 1.92l22.932 24.87a6.456 6.456 0 0 0 8.796-.058 6.26 6.26 0 0 0 .028-8.826L65.36 58.444a5.98 5.98 0 0 1-1.198-7.256A31.996 31.996 0 0 0 67.97 34.62C67.474 17.391 53.236 3.753 36.002 4h-.018C18.334 4.034 4.034 18.334 4 35.984c-.257 17.241 13.384 31.49 30.62 31.986a31.954 31.954 0 0 0 16.57-3.81 6.02 6.02 0 0 1 2.86-.726h-.002z",
    fill: "#717171",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f80f480fd29b2d34ae4445787c0ea5fa.svg";
export { ForwardRef as ReactComponent };